import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import {} from 'react';
import { useOverridableChannelState, useOverridableChannelStatus, } from '../../utils/OverridableChannelStore.js';
import { configStore, } from './ConfigStore.js';
export function ConfigProvider({ children, }) {
    const status = useOverridableChannelStatus(configStore);
    const [config] = useOverridableChannelState(configStore);
    if (status !== 'ready') {
        // Config loading...
        return _jsx("div", {});
    }
    if (config.state === 'uninitialized') {
        // Config uninitialized...
        return _jsx("div", {});
    }
    if (config.state === 'error') {
        // TODO: retry button
        return _jsxs("div", { children: ["Config error: ", config.error.message] });
    }
    return (_jsx(_Fragment, { children: children }));
}
export function useConfig() {
    const [config] = useOverridableChannelState(configStore);
    if (config.state !== 'initialized') {
        throw new Error('Config not initialized');
    }
    return config;
}
//# sourceMappingURL=ConfigProvider.js.map